import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/track-shipment',
    name: 'Track Shipment',
    component: () => import('../views/TrackShipment.vue'),
    meta: { title: 'Track Shipment' }
  },
  {
    path: "/pricing-and-plans",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Page On Maintenance' }
  },{
    path: "/custom-clearance-brokerage",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Custom Clearance & Brokerage - Page On Maintenance' }
  },
  {
    path: "/warehousing-distribution",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Warehousing and Distribution - Page On Maintenance' }
  },
  {
    path: "/freight-forwarding",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'International & Domestic Freight Forwarding - Page On Maintenance' }
  },
  {
    path: "/air-sea-freight",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Air & Sea Freight Services - Page On Maintenance' }
  },
  {
    path: "/fcl-lcl-shipments",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'FCL & LCL Shipments - Page On Maintenance' }
  },
  {
    path: "/nvocc",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'NVOCC - Page On Maintenance' }
  },
  {
    path: "/inland-inter-island-logistics",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Inland & Inter Island Logistics - Page On Maintenance' }
  },
  {
    path: "/project-cargo",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Project Cargo - Page On Maintenance' }
  },
  {
    path: "/ddu-ddp-services",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'DDU & DDP Services - Page On Maintenance' }
  },
  {
    path: "/dg-handling-solution",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'DG Handling Solution - Page On Maintenance' }
  },
  {
    path: "/heavy-lift-operations",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Heavy Lift Operations - Page On Maintenance' }
  },
  {
    path: "/dry-bulk-break-bulk",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Dry Bulk & Break Bulk Logistics - Page On Maintenance' }
  },
  {
    path: "/customized-logistics",
    component: () => import('../components/Maintenance.vue'),
    meta: { title: 'Customized Logistics - Page On Maintenance' }
  },
  {
    path: "/:catchAll(.*)",
    component: () => import('../views/NotFound.vue'),
    meta: { title: 'Page Not Found' }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta && to.meta.title ? 'TAT SING INTL LOGISTIC ' + to.meta.title : 'TAT SING INTL LOGISTIC';
  store.commit('isLoading')
  next();
})

router.afterEach(() => {
  store.commit('isFinishedLoading')
})

export default router
